module.exports = __webpack_public_path__ + "img/created-group.9de1532b.svg";